import React from 'react';
import { useGetInvitedByLegalTransaction } from '../../hooks/reactQuerys/LegalClientInvited';
import { Skeleton, Typography } from '@mui/material';
import { LegalClientsInvitedTable } from './LegalClientsInvitedTable';

interface IProps {
  idLegalTransaction: number;
}

export const LegalClientsInvitedOverview: React.FC<IProps> = ({
  idLegalTransaction,
}) => {
  const { invites, isFetchingInvites, refetchInvites } =
    useGetInvitedByLegalTransaction(idLegalTransaction);

  if (isFetchingInvites) {
    return (
      <>
        <Typography variant='h6' sx={{ mt: 2, mb: -5 }}>
          Einladungen
        </Typography>
        <Skeleton height={200} />
      </>
    );
  } else {
    return (
      <>
        <Typography variant='h6' sx={{ mt: 4, mb: 2 }}>
          Einladungen
        </Typography>
        <LegalClientsInvitedTable invites={invites || []} />
      </>
    );
  }
};
